import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = `${API_BASE_URL}get_test_rate_details_for_updation`;
const PER_PAGE = 15;

const TestRateList = () => {
    const [data, setData] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [areaFilter, setAreaFilter] = useState("All");
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [editedRates, setEditedRates] = useState({});

    useEffect(() => {
        axios.get(API_URL)
            .then((res) => {
                const apiData = res.data?.data || [];
                setData(apiData);
                setFiltered(apiData);
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
            });
    }, []);

    useEffect(() => {
        let result = [...data];

        if (areaFilter !== "All") {
            result = result.filter((item) => item.area === areaFilter);
        }

        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase();
            result = result.filter(
                (item) =>
                    item.test_code.toLowerCase().includes(term) ||
                    item.test_name.toLowerCase().includes(term)
            );
        }

        setFiltered(result);
        setCurrentPage(1);
    }, [searchTerm, areaFilter, data]);

    const uniqueAreas = ["All", ...new Set(data.map((item) => item.area))];
    const totalPages = Math.ceil(filtered.length / PER_PAGE);
    const paginatedData = filtered.slice((currentPage - 1) * PER_PAGE, currentPage * PER_PAGE);

    const handleRateChange = (id, newRate) => {
        const item = data.find((item) => item.id === id);
        const oldRate = item.test_rate;
        const testCode = item.test_code;
        const testName = item.test_name;
        const Area = item.area;


        // Skip if same as old
        if (String(oldRate) === String(newRate)) return;

        // Update editedRates only
        setEditedRates((prev) => ({
            ...prev,
            [id]: newRate
        }));

        // Send POST request
        axios.post(`${API_BASE_URL}test_rate_details_updatation`, {
            id,
            old_rate: oldRate,
            new_rate: newRate,
            test_code: testCode,
            test_name: testName,
            area: Area,

        })
            .then((res) => {
                console.log("Update Success:", res.data);
            })
            .catch((err) => {
                console.error("Update Failed:", err);
            });
    };



    const pageNumbersToShow = () => {
        const delta = 2;
        let range = [];

        for (let i = Math.max(1, currentPage - delta); i <= Math.min(totalPages, currentPage + delta); i++) {
            range.push(i);
        }

        return range;
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.heading}>🧪 Test Rate List</h2>

            <div style={styles.filterBox}>
                <select
                    value={areaFilter}
                    onChange={(e) => setAreaFilter(e.target.value)}
                    style={styles.select}
                >
                    {uniqueAreas.map((area, idx) => (
                        <option key={idx} value={area}>
                            {area}
                        </option>
                    ))}
                </select>

                <input
                    type="text"
                    placeholder="Search test code or name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={styles.search}
                />
            </div>

            <div style={styles.grid}>
                {paginatedData.map((item) => (
                    <div key={item.id} style={styles.card}>
                        <div style={styles.testName}>{item.test_name}</div>
                        <div style={styles.subText}>Code: {item.test_code}</div>
                        <div style={styles.subText}>Area: {item.area}</div>
                        <div style={styles.subText}>
                            Rate: ₹
                            <input
                                type="number"
                                value={editedRates[item.id] || item.test_rate}
                                onChange={(e) => handleRateChange(item.id, e.target.value)}
                                style={styles.inputRate}
                            />
                        </div>
                    </div>
                ))}
            </div>

            <div style={styles.pagination}>
                <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((prev) => prev - 1)}
                    style={styles.pageButton}
                >
                    &lt;
                </button>

                {pageNumbersToShow().map((page) => (
                    <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        style={{
                            ...styles.pageButton,
                            backgroundColor: currentPage === page ? "#2e7d32" : "#c8e6c9",
                            color: currentPage === page ? "#fff" : "#000",
                        }}
                    >
                        {page}
                    </button>
                ))}

                <button
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    style={styles.pageButton}
                >
                    &gt;
                </button>
            </div>
        </div>
    );
};

const styles = {
    container: {
        backgroundColor: "#f4fce3",
        minHeight: "100vh",
        padding: "30px",
        fontFamily: "Arial, sans-serif",
        fontSize: "13px",
    },
    heading: {
        textAlign: "center",
        color: "#2e7d32",
        marginBottom: "20px",
        fontSize: "18px",
    },
    filterBox: {
        display: "flex",
        justifyContent: "center",
        gap: "10px",
        marginBottom: "20px",
        flexWrap: "wrap",
    },
    select: {
        padding: "6px",
        fontSize: "13px",
        borderRadius: "6px",
        border: "1px solid #ccc",
    },
    search: {
        padding: "6px",
        fontSize: "13px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        width: "220px",
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))",
        gap: "15px",
    },
    card: {
        backgroundColor: "#dcedc8",
        padding: "12px",
        borderRadius: "8px",
        boxShadow: "1px 1px 4px rgba(0,0,0,0.1)",
        minHeight: "120px",
    },
    testName: {
        fontWeight: "bold",
        color: "#1b5e20",
        fontSize: "14px",
        marginBottom: "4px",
    },
    subText: {
        fontSize: "12px",
        marginBottom: "2px",
    },
    inputRate: {
        fontSize: "13px",
        padding: "2px 4px",
        width: "80px",
        marginLeft: "4px",
        borderRadius: "4px",
        border: "1px solid #999",
    },
    pagination: {
        marginTop: "20px",
        textAlign: "center",
    },
    pageButton: {
        margin: "0 4px",
        padding: "4px 10px",
        borderRadius: "4px",
        border: "none",
        cursor: "pointer",
        fontSize: "12px",
    },
};

export default TestRateList;
